function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "footerLogoTitle"
}, "Simon Fraser University");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "footerLogoDesc"
}, "\n    Simon Fraser University logo and wordmark\n  ");

var SvgSfuLogoFooter = function SvgSfuLogoFooter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "footerLogoTitle footerLogoDesc",
    role: "img",
    viewBox: "0 0 72.85 63.26",
    width: "100px",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "footerLogoTitle"
  }, title) : null, _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M72.14,36H.14V0h72Z",
    style: {
      fill: "#a6192e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.19,17.92a10.52,10.52,0,0,1-1.28.09,12.31,12.31,0,0,1-1.31-.11c.09.86.11,1.17.14,1.87V22l0,5.36c0,2.14.07,2.59.58,3.44a4.58,4.58,0,0,0,1.33,1.38,6.85,6.85,0,0,0,4.3,1,6.79,6.79,0,0,0,4.26-1.06c1.57-1.1,1.91-2.09,1.91-5.74l0-3.53c0-.3,0-1.06,0-2.3,0-.94,0-1.62,0-2,0-.16,0-.38.07-.7-.52,0-.91.09-1.15.09s-.63,0-1.13-.09c.09.79.14,1.11.16,1.78.07.9.09,2,.09,3.18v3.51c0,2.47-.07,3-.54,3.71a3.26,3.26,0,0,1-.9.77,4.94,4.94,0,0,1-2.73.65,4.59,4.59,0,0,1-3.64-1.42c-.45-.68-.47-.94-.5-3.28v-4.6c0-.25,0-.67.05-1.24s0-.92,0-1.05c0-.79.07-1.13.18-2m-6.12,2.19c0-.48-.07-.84-.07-1.08a6.32,6.32,0,0,1,.11-1.13A11,11,0,0,1,51.4,18H49.1l-2.65,0-1.53,0c.09,1.78.11,2.5.15,3.63v6.17c0,1.62,0,2.68,0,3.19s-.09,1.18-.18,2.1c.52-.05.9-.07,1.17-.07a13.07,13.07,0,0,1,1.42.09,44.92,44.92,0,0,1-.16-5V26.14h2.37a18.8,18.8,0,0,1,2.94.23c0-.48-.07-.84-.07-1.09a7.14,7.14,0,0,1,.12-1.14,14.48,14.48,0,0,1-2.68.2H47.3V20.76l0-.9h2.4c.61,0,1.58,0,2.39.13.2,0,.52.05,1,.12m-12.74.4a9.05,9.05,0,0,1,.32-1.13,4.3,4.3,0,0,1,.4-.89A8.91,8.91,0,0,0,39.59,18a9.8,9.8,0,0,0-2.16-.25A4.61,4.61,0,0,0,33.89,19a4.23,4.23,0,0,0-1.21,3,3.43,3.43,0,0,0,1.55,3,10.91,10.91,0,0,0,2.12,1.12,12,12,0,0,1,2,1.06,2.29,2.29,0,0,1,1.17,1.92c0,1.53-1.24,2.56-3,2.56a5.2,5.2,0,0,1-2.35-.56,6.47,6.47,0,0,1-1.55-1.08,6.81,6.81,0,0,1-.68,2.25,7,7,0,0,0,2.59.81,9.42,9.42,0,0,0,1.51.14,5.32,5.32,0,0,0,4.5-1.92,4.46,4.46,0,0,0,1-2.74,3.65,3.65,0,0,0-.52-2,5.7,5.7,0,0,0-2.59-1.92,16.77,16.77,0,0,1-2.92-1.59,2.23,2.23,0,0,1-.88-1.74,2.11,2.11,0,0,1,2.32-2.16,5.81,5.81,0,0,1,1.44.25,6.87,6.87,0,0,1,2,1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,47.08c-.26-1-.85-1.52-1.57-1.52a1,1,0,0,0-1.13,1c0,.65.36.91,1.51,1.11,1.42.26,2.08.83,2.08,2,0,.68-.43,2-2.45,2a3.49,3.49,0,0,1-2.22-.7V49.31H.64c.17,1.22.81,1.9,1.78,1.9s1.35-.5,1.35-1.18-.23-.93-1.22-1.15C1.1,48.57.25,48.3.25,47a1.92,1.92,0,0,1,2.2-1.9,3.32,3.32,0,0,1,2,.55v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92,51.21l.52,0v.45H6.09v-.45l.55,0,.06-.08V45.66l-.06-.08-.55,0V45.1H8.44v.45l-.52,0-.07.08v5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.26,46.44l-1.51,4.27h-1L11.2,46.38h0v4.75l.06.08.54,0v.45H9.85v-.45l.55,0,.07-.08V45.66l-.07-.08-.55,0V45.1H12c.2.63,1.29,3.59,1.5,4.22h0L15,45.1h2v.45l-.52,0-.06.08v5.47l.06.08.52,0v.45H14.67v-.45l.56,0,.07-.08V46.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.46,48.37c0,2-.52,3.37-2.61,3.37s-2.53-1.41-2.53-3.33c0-1.71.58-3.34,2.64-3.34S23.46,46.53,23.46,48.37Zm-3.87.06c0,1.41.08,2.79,1.32,2.79s1.27-1.33,1.27-3c0-1.4-.13-2.6-1.27-2.6S19.59,46.78,19.59,48.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.63,50V45.66l-.07-.08-.56,0V45.1h1.9v.45l-.52,0-.08.08v6h-.92l-3.29-5.17h0v4.61l.09.08.51,0v.45H24.75v-.45l.55,0,.07-.08V45.66l-.07-.08-.54,0V45.1h1.72L29.61,50Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.55,51.13l.07.08.56,0v.45h-2.4v-.45l.56,0,.06-.08V45.67l-.06-.09-.56,0v-.45h4.74v1.54h-.44c-.26-1-.41-1-1.33-1H36.56v2.59h.73c.79,0,.84-.09,1-.87h.42v2.27h-.42c-.16-.78-.24-.89-1-.89h-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.57,45.1c1.6,0,2.2.77,2.2,1.81a1.7,1.7,0,0,1-1.32,1.74L45.83,51a.34.34,0,0,0,.3.19l.4.08v.39H44.89c-.22-.49-1.31-2.43-1.52-2.91h-.72v2.35l.06.08.52,0v.45H40.87v-.45l.55,0,.08-.08V45.66l-.08-.08-.55,0V45.1Zm-.17.5h-.76v2.68h.73c.63,0,1.13-.49,1.13-1.37S44,45.6,43.4,45.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.22,45.11l2.05,6,.08.08.43,0v.45H51.44v-.45l.59,0,.06-.06L51.7,50H49.3l-.39,1.14.05.08.61,0v.45H47.65v-.45l.47,0,.06-.08,2.08-6Zm-1.75,4.37h2.06l-1-3h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.84,47.08c-.26-1-.85-1.52-1.57-1.52a1,1,0,0,0-1.13,1c0,.65.36.91,1.51,1.11,1.42.26,2.09.83,2.09,2,0,.68-.44,2-2.46,2a3.49,3.49,0,0,1-2.22-.7V49.31h.45c.17,1.22.82,1.9,1.78,1.9s1.35-.5,1.35-1.18-.23-.93-1.22-1.15c-1.45-.31-2.3-.58-2.3-1.92a1.92,1.92,0,0,1,2.2-1.9,3.32,3.32,0,0,1,2,.55v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.47,49.41c-.15-.77-.23-.88-1-.88h-.76v2.65h1.19c.93,0,1.23,0,1.42-1.28h.44v1.79H61v-.45l.56,0,.06-.08V45.67l-.06-.09-.56,0v-.45H65.7v1.54h-.43c-.27-1-.42-1-1.34-1H62.74V48h.75c.78,0,.83-.11,1-.89h.42v2.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.88,45.1c1.61,0,2.2.77,2.2,1.81a1.69,1.69,0,0,1-1.31,1.74L72.15,51a.34.34,0,0,0,.3.19l.4.08v.39H71.21c-.22-.49-1.31-2.43-1.52-2.91H69v2.35l.06.08.51,0v.45H67.19v-.45l.55,0,.08-.08V45.66l-.08-.08-.55,0V45.1Zm-.16.5H69v2.68h.73c.63,0,1.13-.49,1.13-1.37S70.36,45.6,69.72,45.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71,57.07l-.54,0V56.6H6v.45l-.5,0-.08.09v3.66a2.12,2.12,0,0,1-2.38,2.44c-2,0-2.46-1.12-2.46-2.41V57.16l0-.09-.55,0V56.6H2.34v.45l-.53,0a.26.26,0,0,1-.05.09V60.9c0,.94.25,1.77,1.52,1.77,1.42,0,1.51-1,1.51-1.85V57.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.24,61.48V57.16l-.06-.09-.57,0V56.6h1.9v.45l-.52,0-.08.09v6H12L8.69,58h0v4.61l.1.08.5,0v.45H7.36v-.45l.56,0L8,62.63V57.16l-.06-.09-.55,0V56.6H9.1l3.12,4.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75,62.71l.52,0v.45H14.92v-.45l.55,0,.06-.08V57.16l-.06-.09-.55,0V56.6h2.35v.45l-.52,0-.06.09v5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,63.19l-1.92-6L19,57.08l-.45,0v-.45H20.9v.45l-.58,0-.07.09,1.46,4.73h0c.22-.73,1.25-4,1.47-4.73l-.06-.09-.6,0v-.45h1.9v.45l-.47,0-.06.09-1.94,6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.26,60.91c-.15-.77-.24-.88-1-.88h-.76v2.65h1.19c.93,0,1.23,0,1.42-1.28h.44v1.79H25.74v-.45l.56,0,.07-.08V57.17l-.07-.09-.56,0v-.45h4.75v1.54h-.44c-.26-1-.41-1-1.33-1H27.53v2.41h.75c.78,0,.83-.11,1-.89h.41v2.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.67,56.6c1.6,0,2.2.77,2.2,1.81a1.69,1.69,0,0,1-1.31,1.74l1.38,2.38c.08.14.13.16.3.19l.39.08v.39H36c-.22-.49-1.3-2.43-1.52-2.91h-.72v2.35l.07.08.51,0v.45H32v-.45l.55,0,.07-.08V57.16l-.07-.09-.55,0V56.6Zm-.16.5h-.77v2.68h.73c.63,0,1.13-.49,1.13-1.37S35.14,57.1,34.51,57.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.65,58.58c-.25-1-.85-1.52-1.57-1.52a1,1,0,0,0-1.13,1c0,.65.37.91,1.51,1.11,1.43.25,2.09.83,2.09,2,0,.68-.44,2-2.46,2a3.51,3.51,0,0,1-2.22-.7V60.81h.46c.17,1.22.81,1.9,1.77,1.9s1.35-.5,1.35-1.18-.22-.93-1.22-1.15c-1.45-.31-2.3-.58-2.3-1.92a1.93,1.93,0,0,1,2.2-1.9,3.32,3.32,0,0,1,2,.55v1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,62.71l.51,0v.45H44.77v-.45l.55,0,.07-.08V57.16l-.07-.09-.55,0V56.6h2.35v.45l-.51,0-.07.09v5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84,58.2H48.4V56.61h5.17V58.2h-.43c-.21-1-.4-1.08-1.32-1.08h-.26v5.51l.06.08.52,0v.45H49.78v-.45l.56,0,.07-.08V57.12h-.26C49.24,57.12,49.07,57.21,48.84,58.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,60.51v2.12l.06.08.52,0v.45H56.24v-.45l.56,0,.07-.08v-2l-1.63-3.44-.07-.09-.46,0V56.6h2.38v.45l-.58,0-.07.08,1.22,2.63h.05l1.21-2.62-.05-.09-.61,0V56.6h1.9v.45l-.45,0-.07.09Z",
    style: {
      fill: "#fff"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSfuLogoFooter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sfu-logo-footer.41f86512.svg";
export { ForwardRef as ReactComponent };